var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { fromEntries } from '../utils/fromEntries';
import { isPlainObject } from '../utils/isPlainObject';
export var ThrownError = Symbol('ThrownError');
var DispatchedAction = Symbol('/retil/dispatched-action');
var Dispatch = Symbol('/retil/dispatch');
var Kind = Symbol('/retil/kind');
var Namespace = Symbol('/retil/namespace');
var Register = Symbol('/retil/register');
var Reset = Symbol('/retil/reset');
export function createInnerStore(preloadedState, createReduxStore, selector) {
    if (preloadedState === void 0) { preloadedState = {}; }
    var namespaceInitialStates = {};
    var namespaceReducers = {};
    var reducer = createStoreReducer({}, {});
    var reduxStore = createReduxStore(reducer, preloadedState);
    var getState = selector
        ? function () { return selector(reduxStore.getState()); }
        : reduxStore.getState;
    return {
        dispatch: function (namespace, action) {
            var _a;
            if (!isPlainObject(action)) {
                throw new Error('Actions must be plain objects.');
            }
            if (action.type === undefined) {
                throw new Error('Actions may not have an undefined "type" property. ' +
                    'Have you misspelled a constant?');
            }
            reduxStore.dispatch(__assign(__assign((_a = {}, _a[Kind] = Dispatch, _a[Namespace] = namespace, _a[DispatchedAction] = action, _a), action), { type: '/' + namespace + '/' + action.type }));
        },
        getState: getState,
        getThrownError: function () { return reduxStore.getState()[ThrownError]; },
        reset: function () {
            var _a;
            reduxStore.dispatch((_a = {},
                _a[Kind] = Reset,
                _a.type = '/retil/reset',
                _a));
        },
        register: function (namespace, reducer, preloadedState) {
            var _a;
            namespaceInitialStates[namespace] = preloadedState;
            namespaceReducers[namespace] = reducer;
            reduxStore.replaceReducer(createStoreReducer(namespaceReducers, namespaceInitialStates));
            reduxStore.dispatch((_a = {},
                _a[Kind] = Register,
                _a[Namespace] = namespace,
                _a.type = '/retil/register',
                _a.namespace = namespace,
                _a));
        },
        subscribe: reduxStore.subscribe,
    };
}
function createStoreReducer(reducers, preloadedStates) {
    var namespaces = Object.keys(reducers);
    return function (state, action) {
        var _a, _b, _c;
        var namespace = action[Namespace] || '';
        var reducer = reducers[namespace];
        // Thrown errors are unrecoverable, but we want them to be thrown when the
        // user calls `getState` -- not in the middle of the reducer.
        if (ThrownError in state) {
            return state;
        }
        switch (action[Kind]) {
            case Dispatch:
                var oldState = state[namespace];
                var newState = void 0;
                try {
                    newState = reducer(oldState, action[DispatchedAction]);
                    return oldState === newState
                        ? state
                        : __assign(__assign({}, state), (_a = {}, _a[namespace] = newState, _a));
                }
                catch (error) {
                    console.error('Store Error: exception thrown in reducer:', error);
                    return __assign(__assign({}, state), (_b = {}, _b[ThrownError] = error, _b[namespace] = ThrownError, _b));
                }
            case Register:
                return __assign(__assign({}, state), (_c = {}, _c[namespace] = reducer(preloadedStates[namespace], action), _c));
            case Reset:
                return fromEntries(namespaces.map(function (namespace) { return [namespace, preloadedStates[namespace]]; }));
            default:
                return state;
        }
    };
}
//# sourceMappingURL=InnerStore.js.map